module.exports = __webpack_public_path__ + "img/internal-onboarding-2.e30d6a87.jpeg";